import { v as bvVar, requireScript } from 'bv';

const { JSBundles } = window;

export default () => {
  if (bvVar('onetrustEnabled')) return;

  const show = document.cookie.indexOf('accepted_cookies_policy') === -1
    && document.cookie.indexOf('OptanonAlertBoxClosed') === -1;

  if (show) {
    requireScript(JSBundles.cookiesPolicy).then(() => {
      window.CookiesPolicy.default();
    });
  }
};
